import {genericStyled} from './GenericStyled';
import "./BasicBlocks.css";

export const LocalShadow = genericStyled("StyledLocalShadow");
export const PopupWrapper = genericStyled("StyledPopupWrapper");
export const CloseButton = genericStyled("button StyledIconButton StyledCloseButton");
export const PopupButton = genericStyled("button saveButton StyledPopupButton");